export default "__VITE_ASSET__e00bf2de__"